var _circle, _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebuggerNoErrorsIcon = function SvgDebuggerNoErrorsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#3D4355"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F14668",
    fillRule: "evenodd",
    d: "m34.577 31.749-6.364-6.364 6.364-6.364a2 2 0 0 0-2.828-2.829l-6.364 6.364-6.364-6.364a2 2 0 1 0-2.829 2.829l6.364 6.364-6.364 6.364a2 2 0 1 0 2.829 2.828l6.364-6.364 6.364 6.364a2 2 0 0 0 2.828-2.828",
    clipRule: "evenodd",
    opacity: 0.4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "DebuggerNoErrorsIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m34.577 31.749-6.364-6.364 6.364-6.364a2 2 0 0 0-2.828-2.829l-6.364 6.364-6.364-6.364a2 2 0 1 0-2.829 2.829l6.364 6.364-6.364 6.364a2 2 0 1 0 2.829 2.828l6.364-6.364 6.364 6.364a2 2 0 0 0 2.828-2.828",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "m28.213 25.385-.707-.707-.707.707.707.707zm-2.828-2.829-.707.707.707.708.707-.708zm-2.829 2.829.707.707.708-.707-.707-.707zm2.829 2.828.707-.707-.707-.707-.707.707zm2.121-2.121 6.364 6.364 1.414-1.414-6.364-6.364zm6.364-7.778-6.364 6.364 1.414 1.414 6.364-6.364zm0-1.415a1 1 0 0 1 0 1.415l1.414 1.414a3 3 0 0 0 0-4.243zm-1.414 0a1 1 0 0 1 1.414 0l1.414-1.414a3 3 0 0 0-4.242 0zm-6.364 6.364 6.364-6.364-1.414-1.414-6.364 6.364zM18.314 16.9l6.364 6.364 1.414-1.414-6.364-6.364zm-1.415 0a1 1 0 0 1 1.415 0l1.414-1.414a3 3 0 0 0-4.243 0zm0 1.415a1 1 0 0 1 0-1.415l-1.414-1.414a3 3 0 0 0 0 4.243zm6.365 6.364L16.9 18.314l-1.415 1.414 6.364 6.364zM16.9 32.456l6.364-6.364-1.415-1.414-6.364 6.364zm0 1.414a1 1 0 0 1 0-1.414l-1.415-1.414a3 3 0 0 0 0 4.242zm1.414 0a1 1 0 0 1-1.415 0l-1.414 1.414a3 3 0 0 0 4.243 0zm6.364-6.364-6.364 6.364 1.414 1.414 6.364-6.364zm7.778 6.364-6.364-6.364-1.414 1.414 6.364 6.364zm1.414 0a1 1 0 0 1-1.414 0l-1.414 1.414a3 3 0 0 0 4.242 0zm0-1.414a1 1 0 0 1 0 1.414l1.414 1.414a3 3 0 0 0 0-4.242z",
    mask: "url(#DebuggerNoErrorsIcon_svg__a)"
  })));
};
export default SvgDebuggerNoErrorsIcon;